import { openBlock as r, createElementBlock as e, createStaticVNode as o } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function a(c, t) {
  return r(), e("svg", l, [...t[0] || (t[0] = [
    o('<mask id="a" fill="#fff"><path d="M4 20V4h10.667L20 9.333V20z"></path></mask><path stroke="currentColor" stroke-width="2" d="M4 20V4h10.667L20 9.333V20z" mask="url(#a)"></path><circle cx="12" cy="14" r="2.5" stroke="currentColor"></circle><path fill="currentColor" d="M7 7h6v2H7z"></path>', 4)
  ])]);
}
const s = { render: a };
export {
  s as default,
  a as render
};
